import { i18n } from '@lingui/core';
import { I18nProvider as LinguiI18nProvider } from '@lingui/react';
import { type FC, type ReactNode, useEffect } from 'react';
import { type Settings, useSettings, useUrlLanguageSync } from '@/settings/api';
import { getSettings } from '@/settings/config';
import { ar, ckb, config, en } from './locales';

i18n.load('en', en);
i18n.load('ar', ar);
i18n.load('ckb', ckb);

i18n.on('change', () => {
  const locale = i18n.locale;
  const html = window.document.documentElement;
  html.setAttribute(
    'dir',
    (config[locale as Settings['language']]?.dir as never) || 'ltr',
  );
  html.setAttribute('lang', locale);
  window.localStorage.setItem('locale', locale);
});

i18n.activate(getSettings().language);

export const I18nProvider: FC<{ children?: ReactNode }> = ({ children }) => {
  const [settings] = useSettings();
  useUrlLanguageSync();
  useEffect(() => {
    if (i18n.locale !== settings.language) {
      i18n.activate(settings.language);
    }
  }, [settings.language]);
  return <LinguiI18nProvider i18n={i18n}>{children}</LinguiI18nProvider>;
};

export { config } from './locales';
export * from './useDirection';
